
import React, { useState, useEffect } from "react";
import { UserPayload } from "../Services/userService"; // Import UserPayload
import { IUser } from "../Interfaces/IUser";
import Swal from "sweetalert2";
import { indianStates } from "../Services/CommonService";

interface EditUserProps {
  onSave: (data: UserPayload) => void;
  onClose: () => void;
  type: "customer" | "vendor" | "salesPerson";
  orgId: string;
  user?: IUser; // User prop to edit
}

const EditUser: React.FC<EditUserProps> = ({
  onSave,
  onClose,
  type,
  orgId,
  user,
}) => {
  const [formData, setFormData] = useState<UserPayload>({
    customerId:user?.Id || "",
    salutation: user?.salutation || "Mr.",
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    companyName: user?.companyName || "",
    displayName: user?.displayName || "",
    email: user?.email || "",
    phone: user?.phone || "",
    address: user?.address || {
      street: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
    },
    website: user?.website || "",
    orgId: orgId,
    GSTIN: user?.GSTIN || "",
    userType: user?.userType || type,
    
  });

  useEffect(() => {
    if (user) {
      setFormData({
        ...formData,
        ...user,
      });
    }
  }, [user]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    if (name.includes("address.")) {
      const [_, key] = name.split(".");
      setFormData((prevData) => ({
        ...prevData,
        address: {
          ...prevData.address,
          [key]: value,
        },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // const handleSubmit = () => {
  //   onSave(formData);
  // };
  const validateForm = () => {
    const errors: string[] = [];
    const {firstName,phone,customerName,userType} = formData;


    if (userType === "customer" || userType==="vendor") {
      if (!customerName) {
        errors.push("User Name is required.");
      }
      if (!phone) {
        errors.push("Phone is required.");
      }
      if (!formData.address?.state) {
        errors.push("State is required.");
      }
    }
    else
    {
      if (!firstName) {
        errors.push("Sales Person First Name is required.");
      }
    }
    return errors;
  };

  const handleSubmit = () => {
    const validationErrors = validateForm();
    if (validationErrors.length > 0) {
      Swal.fire({
        title: "Validation Errors",
        text: validationErrors.join("\n"),
        icon: "error",
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          container: 'swal-validation-errors'
        },
        backdrop: `
          rgba(0,0,0,0.4)
          center
          no-repeat
        `
      });
      const swalValidationErrors = document.querySelector('.swal-validation-errors') as HTMLElement;
      if (swalValidationErrors) {
        swalValidationErrors.style.zIndex = '10000';
      }
      return; // Stop submission if there are validation errors
    }
    onSave(formData);
  };
  return (
    
    <div className="popup">
      <div className="popup-content">
        {/* <button className="close-button" style={{ position: "fixed", top: 0, right: 0 }} onClick={onClose}>
          &times;
        </button> */}
      <div className="editUser-header">
      <h3>Edit User</h3>
        
        {/* <p className="name">{formData.firstName} {formData.lastName}</p> */}
      </div>
      <div className="editUser-body">
      {/* <button onClick={onClose} className="close-button">
          &#10006;
        </button> */}
        <form className="editUser-form">
        {formData.userType === "customer" || formData.userType === "vendor" ? (
           <>
          <div className="input-group">
            <label className="label">User Name<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="customerName"
              value={formData.customerName}
              onChange={handleChange}
              required
              className="input-field"
            />
          </div>
          </>
           ):(
            <div className="inline-fields">
              <select
                name="salutation"
                value={formData.salutation}
                onChange={handleChange}
              >
                <option value="Mr.">Mr.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Ms.">Ms.</option>
              </select>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First Name"
                required
              />
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Last Name"
                //required
              />
            </div>)}
          {/* <div className="input-group">
            <label className="label">Last Name</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              //required
              className="input-field"
              

            />
          </div> */}
           
           {(type === "customer" || type === "vendor") && (
  <div className="form-group">
    <label>
      GST
      {/* <span style={{ color: "red" }}>*</span> */}
    </label>
    <input
      type="text"
      name="GSTIN"
      value={formData.GSTIN}
      onChange={handleChange}
      placeholder="GST"
      // required
    />
  </div>
)}
          <div className="input-group two-in-one">
            <label className="label">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              
              className="input-field"
            />
            <label className="label">Contact Phone<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={(e) => {
                const value = e.target.value;
                if (value.startsWith('-')) {
                  Swal.fire({
                    title: "Error",
                    text: "Mobile number should not be negative",
                    icon: "error",
                    customClass: {
                      container: 'swal-validation-errors'
                    },
                    backdrop: `
                        rgba(0,0,0,0.4)
                        center
                        no-repeat
                    `
                  });
                  const swalValidationErrors = document.querySelector('.swal-validation-errors') as HTMLElement;
                  if (swalValidationErrors) {
                    swalValidationErrors.style.zIndex = '10000';
                  }
                  setFormData((prev) => ({
                    ...prev,
                    phone: "",
                  }));
                } else if (value.length > 13) {
                  Swal.fire({
                    title: "Error",
                    text: "Mobile number is invalid",
                    icon: "error",
                    customClass: {
                      container: 'swal-validation-errors'
                    },
                    backdrop: `
                        rgba(0,0,0,0.4)
                        center
                        no-repeat
                    `
                  });
                  const swalValidationErrors = document.querySelector('.swal-validation-errors') as HTMLElement;
                  if (swalValidationErrors) {
                    swalValidationErrors.style.zIndex = '10000';
                  }
                  setFormData((prev) => ({
                    ...prev,
                    phone: "",
                  }));
                } else {
                  setFormData((prev) => ({
                    ...prev,
                    phone: value,
                  }));
                }
              }}
              required
              className="input-field"
            />
          </div>
          {/* <div className="input-group">
            <label className="label">Company<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              required
              className="input-field"
            />
          </div> */}
         
          <div className="input-group">
            <label className="label">Street</label>
            <textarea
              name="address.street"
              value={formData.address.street}
              onChange={handleChange}
              placeholder="Street"
              className="input-field"
            />
            <label>
            City
            {/* <span style={{ color: "red" }}>*</span> */}
          </label>
            <input 
              type="text"
              name="address.city"
              value={formData.address.city}
              onChange={handleChange}
              placeholder="City"
              className="input-field"
            />
              <label className="label"> State <span style={{ color: "red" }}>*</span></label>
              <select
                  name="address.state"
                  value={formData.address.state}
                  onChange={handleChange}
                  required
                  >
                  <option value="">Select State</option>
                  {indianStates.map((state) => (
                    <option key={state.value} value={state.label} >
                      {state.label}
                    </option>
                  ))}
                </select>
            <label className="label">Zip Code</label>
            <input 
              type="text"
              name="address.zipCode"
              value={formData.address.zipCode}
              onChange={handleChange}
              placeholder="Zip Code"
              className="input-field"
            />
          </div>
          {/* <div className="input-group">
            <label className="label">Website</label>
            <input
              type="url"
              name="website"
              value={formData.website}
              onChange={handleChange}
              className="input-field"
            />
          </div> */}
           <div className="form-group">
          <label>
            Country
            <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="address.country"
            value={formData.address.country}
            onChange={handleChange}
            placeholder="Country"
            disabled
          />
        </div>
          <div className="popup-buttons">
            <button onClick={handleSubmit} className="popup-button">
              {user ? "Save Changes" : "Add User"}
            </button>
            <button onClick={onClose} className="popup-button">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
    </div>
  );
};
export default EditUser;
